export var FactorDevice;
(function (FactorDevice) {
    FactorDevice["Authenticator"] = "authenticator";
    FactorDevice["Authy"] = "authy";
})(FactorDevice || (FactorDevice = {}));
//# sourceMappingURL=factor-device.js.map